import React, { Component } from "react";
import { VictoryLine, VictoryChart } from 'victory'
class Modal extends Component {
  render() {
    return (
      <div>
        <div
          id="modal"
          style={{
            zIndex: "10",
            position: "fixed",
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
          onClick={function (e) {
            if (e.target !== e.currentTarget) return;
            e.currentTarget.style.display = "none";
          }}
        >
          <div
            id="container"
            style={{
              display: "flex",
              flexDirection: "column",
              position: "fixed",
              width: "auto",
              height: "auto",
              maxWidth: "80%",
              maxHeight: "80%",
              backgroundColor: "#FFF",
              padding: "0px 32px",
              paddingBottom: "32px",
              borderRadius: "5px",
              border: "2px solid #555",
              boxShadow:
                "rgba(14, 30, 37, 0.12) 0px 2px 4px 0px, rgba(14, 30, 37, 0.32) 0px 2px 16px 0px",
              overflowY: "scroll",
            }}
            onClick={function (e) {
              console.log("container clicked");
            }}
          >
            <h2 id="name" style={{}}>
              Name of Item <span id='fire_rate' style={{visibility:'visible'}}>0</span>
            </h2>
            <h4>Temperature last 30 days</h4>
            <div
            style={{width:'50%'}}>
              <VictoryChart
              
              minDomain={{ y: 0 }}>
                <VictoryLine 
                
                data={[
                  { x: 1, y: Math.random()*10 + 70 },
                  { x: 2, y: Math.random()*10 + 71 },
                  { x: 3, y: Math.random()*10 + 72 },
                  { x: 4, y: Math.random()*10 + 74 },
                  { x: 5, y: Math.random()*10 + 79 },
                  { x: 6, y: Math.random()*10 + 72 },
                  { x: 7, y: Math.random()*10 + 79 },
                  { x: 8, y: Math.random()*10 + 80 },
                  { x: 9, y: Math.random()*10 + 88 },
                  { x: 10, y: Math.random()*10 + 71 },
                  { x: 11, y: Math.random()*10 + 82 },
                  { x: 12, y: Math.random()*10 + 90 },
                  { x: 13, y: Math.random()*10 + 99 },
                  { x: 14, y: Math.random()*10 + 82 },
                  { x: 15, y: Math.random()*10 + 85 },
                  { x: 16, y: Math.random()*10 + 76 },
                  { x: 17, y: Math.random()*10 + 74 },
                  { x: 18, y: Math.random()*10 + 72 },
                  { x: 19, y: Math.random()*10 + 79 },
                  { x: 20, y: Math.random()*10 + 89 },
                  { x: 21, y: Math.random()*10 + 85 },
                  { x: 22, y: Math.random()*10 + 88 },
                  { x: 23, y: Math.random()*10 + 86 },
                  { x: 24, y: Math.random()*10 + 87 },
                  { x: 25, y: Math.random()*10 + 82 },
                  { x: 26, y: Math.random()*10 + 89 },
                  { x: 27, y: Math.random()*10 + 88 },
                  { x: 28, y: Math.random()*10 + 81 },
                  { x: 29, y: Math.random()*10 + 84 },
                  { x: 30, y: Math.random()*10 + 80 },

                ]}>
                </VictoryLine>
              </VictoryChart>
              
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default Modal;
